export class  returnsUrl  {
    UPLOAD_URL = "ssr/v2/return/upload";
    UPLOADED_RETURNS_URL = "ssr/v2/return/uploaded-returns";
    APPEND_URL = "ssr/v2/return/append";
    FETCH_RETURN_DETAILS_URL = "ssr/v2/return/{taxReturnId}";
    PARTIAL_UPLOAD_URL = "ssr/v2/return/partial-upload";
    RECOGNIZE_URL = "ssr/v2/return/recognize";
    SET_ACCESS_URL = "ssr/v2/return/set-access";
    UN_RECOGNIZED_RETURNS_URL = "ssr/v2/return/unrecognized-returns";
}
